import { interpolate, useCurrentFrame } from 'remotion';

// Constants
import { CLAMP_BOTH } from '@/constants/animations';
import {
  WAVE_BUBBLES,
  BUBBLE_ANIMATION,
  WAVE_COLORS,
  WAVE_ANIMATION,
} from '../../constants';

interface BubblesAnimationProps {
  slideInOffset: number;
}

export const BubblesAnimation = ({ slideInOffset }: BubblesAnimationProps) => {
  const frame = useCurrentFrame();

  // Vertical sine offset to simulate wave ripple.
  const rippleY =
    Math.sin((frame / WAVE_ANIMATION.ripplePeriod) * 2 * Math.PI) *
    WAVE_ANIMATION.rippleAmplitude;

  return (
    <svg
      className="absolute left-0 w-full"
      viewBox="0 0 1920 300"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ top: `${slideInOffset}%`, height: '35%' }}
    >
      {/* Wave path and bubbles move together with the ripple */}
      <g transform={`translate(0, ${rippleY})`}>
        <path
          d="M187.912 186.739C99.8672 175.904 -0.0303383 222.858 -38.9735 247.689L-49.1328 -201.003H1935.27V135.94C1894.63 98.6899 1771.03 100.383 1684.68 127.474C1598.32 154.565 1388.37 295.097 1263.08 193.507C1137.78 91.9167 1093.76 113.928 1044.66 144.405C995.972 174.623 952.281 158.235 911.933 143.101L910.896 142.712C870.26 127.473 849.942 183.35 756.817 149.486C663.693 115.623 592.579 135.942 506.228 174.885C419.876 213.828 297.967 200.282 187.912 186.739Z"
          fill={WAVE_COLORS.waveFill}
        />

        {WAVE_BUBBLES.map(({ cx, cy, rx, ry, rotate, delay = 0 }, index) => {
          // Progress through the pulse cycle, staggered per bubble.
          const cycleProgress =
            (Math.max(0, frame - delay * BUBBLE_ANIMATION.staggerStep) %
              BUBBLE_ANIMATION.cycleDuration) /
            BUBBLE_ANIMATION.cycleDuration;

          const value = interpolate(
            cycleProgress,
            [0, BUBBLE_ANIMATION.peakStart, BUBBLE_ANIMATION.peakEnd, 1],
            [0, 1, 1, 0],
            CLAMP_BOTH,
          );

          return (
            <g
              key={index}
              {...(rotate != null && {
                transform: `rotate(${rotate}, ${cx}, ${cy})`,
              })}
            >
              <ellipse
                cx={cx}
                cy={cy}
                rx={rx}
                ry={ry}
                fill={WAVE_COLORS.bubbleFill}
                style={{
                  transformBox: 'fill-box',
                  transformOrigin: 'center',
                  transform: `scale(${value})`,
                  opacity: value,
                }}
              />
            </g>
          );
        })}
      </g>
    </svg>
  );
};
